import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './detail.css';

/** Titled section card. `flush` removes body padding for tables/lists. */
const DetailCard = ({
  title,
  hint,
  icon,
  actions,
  flush,
  className,
  children,
}) => (
  <section className={classnames('dt-card', className)}>
    {(title || actions) && (
      <div className='dt-card__head'>
        {icon && (
          <span className='dt-card__icon' aria-hidden='true'>
            <i className={icon} />
          </span>
        )}
        <div className='dt-card__titles'>
          {title && <h2 className='dt-card__title'>{title}</h2>}
          {hint && <p className='dt-card__hint'>{hint}</p>}
        </div>
        {actions}
      </div>
    )}
    <div
      className={classnames('dt-card__body', { 'dt-card__body--flush': flush })}
    >
      {children}
    </div>
  </section>
);

DetailCard.propTypes = {
  title: PropTypes.node,
  hint: PropTypes.node,
  icon: PropTypes.string,
  actions: PropTypes.node,
  flush: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default DetailCard;
